import { render, staticRenderFns } from "./OperationRecord.vue?vue&type=template&id=ff814120&"
import script from "./OperationRecord.vue?vue&type=script&lang=js&"
export * from "./OperationRecord.vue?vue&type=script&lang=js&"
import style0 from "./OperationRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports